import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Label,
  Fieldset,
  Legend,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import Shimmer from "react-shimmer-effect";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";
import Select from "react-select";

import { Link, useHistory, Redirect } from "react-router-dom";

import apiResponse from "../../../../services/apiResponse";

import { accessRole } from "../../../../helpers/access_role";
import CustomSelect from "../../../../helpers/ui/CustomSelect";
import moment from "moment";
import UploadSKBloc from "./Blocs/UploadSKBloc";

var reformatOptionRank = function (datas) {
  return datas.map(function (data) {
    var newObj = {};
    newObj["label"] = `${data.rank_name}`;
    newObj["value"] = data.rank_uuid;
    return newObj;
  });
};

var reformatSignatory = function (regions) {
  return regions.map(function (region) {
    var newObj = {};
    newObj["label"] =
      region.signatories_official_nip +
      " - " +
      region.signatories_official_name;
    newObj["value"] = region.signatories_official_uuid;
    newObj["nip_pejabat"] = region.signatories_official_nip;
    newObj["nama_pejabat"] = region.signatories_official_name;
    return newObj;
  });
};

var reformatOptionDocument = function (regions) {
  return regions.map(function (region) {
    var newObj = {};
    newObj["label"] = region.document_type_name;
    newObj["value"] = region.document_type_uuid;
    return newObj;
  });
};

class IndexView extends Component {
  uploadSKBloc = new UploadSKBloc();

  queryParams = new URLSearchParams(window.location.search);

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {
        nip_pejabat: "",
        nama_pejabat: "",
        sumpahSelected: "",
      },
      rankItems: [],
      rankSelected: "",
      sigantoryItems: [],
      sigantorySelected: "",
      documentTypeItems: [],
      documentTypeSelected: "",
    };
  }

  dateParse = (input) => {
    let res = "";
    if (input != "" && input != null) {
      res = moment(input).format("DD/MM/YYYY");
    }
    return res;
  };

  dateParseYMD = (input) => {
    let res = "";
    if (input != "" && input != null) {
      res = moment(input).format("YYYY-MM-DD");
    }
    return res;
  };

  reformatOptions = (raw, label, value) => {
    return raw.map(function (data) {
      var newObj = {};
      newObj["label"] = data[label];
      newObj["value"] = data[value];

      return newObj;
    });
  };

  onChangeSumpah = (event) => {
    const target = event.target;
    const value = target.checked ? 1 : 0;
    this.setState({
      dataForm: {
        sumpahSelected: value,
      },
    });
  };

  onchangeRank = (rankSelected) => {
    this.setState({
      rankSelected: rankSelected.value,
    });
  };

  onChangeDcoumentType = (documentTypeSelected) => {
    this.setState({
      documentTypeSelected: documentTypeSelected.value,
    });
  };

  onChangeSignatory = (signatory) => {
    this.setState({
      sigantorySelected: signatory.value,
      dataForm: {
        nip_pejabat: signatory.nip_pejabat,
        nama_pejabat: signatory.nama_pejabat,
      },
    });
  };

  errorField = (message) => {
    this.setState({
      loading: false,
      failed: true,
      failedInfo: message,
    });
  };

  downloadDraftSPMT = () => {
    // var no_sk = document.getElementsByName("no_sk")[0].value;
    // var no_spmt = document.getElementsByName("no_spmt")[0].value;
    // var tgl_sk = document.getElementsByName("tanggal_sk")[0].value;
    // var tmt_sk = document.getElementsByName("tanggal_tmt_sk")[0].value;
    // if (no_sk == "") {
    //   this.errorField("No Surat Keputusan Kosong!");
    //   return 0;
    // }

    // if (no_spmt == "") {
    //   this.errorField("No Surat Pernyataan Melaksanakan Tugas Kosong!");
    //   return 0;
    // }

    // if (tgl_sk == "") {
    //   this.errorField("Tanggal Surat Keputusan Kosong!");
    //   return 0;
    // }

    // if (tmt_sk == "") {
    //   this.errorField("Terhitung Mulai Tanggal! Kosong!");
    //   return 0;
    // }

    this.uploadSKBloc.fetchDownloadSPMT({
      cp3k_uuid: this.queryParams.get("uuid"),
      signatory_uuid: "",
      no_sk: "",
      no_spmt: "",
      tgl_sk: "",
      tmt_sk: "",
    });
  };

  downloadTemplatePerjanjian = () => {
    this.uploadSKBloc.fetchDownloadContract({});
  };

  submitData = async () => {
    let files = [
      "document",
      "document_spmt",
      "document_contract",
      "document_kk",
      "document_akta_anak",
      "document_akta_nikah",
      "document_bank",
      "document_npwp",
      "document_prajab",
      "document_mcu",
    ];
    const formData = generateFormData(this.state.dataForm, files); // Jika nama field fileinputnya adalah 'File', maka parameter kedua boleh dikosongkan. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto']
    await this.uploadSKBloc.fetchUploadSk(formData);
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        ...values,
        cp3k_uuid: this.state.detail?.cp3k_uuid,
        employee_uuid: this.state.detail?.employee_uuid,
      },
      confirm: true,
    });
  };

  rupiah = (num) => {
    let res = "-";
    if (num != null && num != "") {
      res = parseFloat(num).toLocaleString("id-ID", {
        maximumFractionDigits: 2,
      });
    }
    return res;
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.uploadSKBloc.uploadSkChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
            failedInfo: "Data gagal disimpan",
          });
          break;
        default:
          break;
      }
    });

    this.uploadSKBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;

            // load to form
            this.setState({
              detail: response,
              birthNational: response.cp3k_candidate_place_of_birth_national,
              rankSelected: response.cp3k_candidate_rank_uuid,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.uploadSKBloc.downloadSPMTChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loading: true,
          });
          break;
        case apiResponse.COMPLETED:
          const link = result.data.response;
          window.open(link.file_url, "_blank");
          //window.location.href = link.file_url
          this.setState({
            loading: false,
            success: true,
          });
          setTimeout(() => {
            this.setState({
              success: false,
            });
          }, 1000);
          break;
        case apiResponse.ERROR:
          this.setState({
            urlFileDetail: link,
            loading: false,
            failed: true,
          });
          setTimeout(function () {
            this.setState({
              failed: false,
            });
          }, 1000);
          break;
        default:
          break;
      }
    });

    this.uploadSKBloc.downloadContractChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loading: true,
          });
          break;
        case apiResponse.COMPLETED:
          const link = result.data.response;
          window.open(link.file_url, "_blank");
          this.setState({
            loading: false,
            success: true,
          });
          setTimeout(() => {
            this.setState({
              success: false,
            });
          }, 1000);
          break;
        case apiResponse.ERROR:
          this.setState({
            urlFileDetail: link,
            loading: false,
            failed: true,
          });
          setTimeout(function () {
            this.setState({
              failed: false,
            });
          }, 1000);
          break;
        default:
          break;
      }
    });

    this.uploadSKBloc.fetchDetail({ uuid: this.queryParams.get("uuid") });

    this.setState({
      dataForm: {
        sumpahSelected: 0,
      },
    });
  }

  componentWillUnmount() {
    this.uploadSKBloc.uploadSkChannel.unsubscribe();
    this.uploadSKBloc.detailChannel.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card className="">
                <CardBody>
                  <CardTitle>
                    {" "}
                    Upload Dokumen PRAJAB & Medical Check Up
                  </CardTitle>
                  <CardSubtitle className="mb-3">
                    Setiap isian yang bertanda (
                    <span className="text-danger">*</span>) adalah wajib diisi.
                  </CardSubtitle>
                  <hr />

                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Penetapan NIP BKN
                      </Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_bkn_confirmation_number"
                          placeholder="Nomor"
                          errorMessage="Masukkan Nomor"
                          type="text"
                          className="form-control"
                          value={
                            this.state.detail?.cp3k_bkn_confirmation_number
                          }
                          validate={{ required: { value: false } }}
                          disabled={true}
                        />
                      </Col>
                      <Col md="3">
                        <AvField
                          name="cp3k_bkn_confirmation_date"
                          placeholder="Tanggal"
                          errorMessage="Masukkan Tanggal"
                          type="date"
                          className="form-control"
                          value={this.state.detail?.cp3k_bkn_confirmation_date}
                          validate={{ required: { value: false } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <hr />

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Nama Lengkap
                      </Label>
                      <Col md="4">
                        <AvField
                          name="cp3k_candidate_name"
                          placeholder="Nama"
                          errorMessage="Masukkan Nama"
                          type="text"
                          className="form-control"
                          value={this.state.detail?.cp3k_candidate_full_name}
                          validate={{ required: { value: false } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Email BKPM
                      </Label>
                      <Col md="5">
                        <AvField
                          name="cp3k_candidate_email"
                          placeholder="Email BKPM"
                          errorMessage="Masukkan Email BKPM"
                          type="email"
                          className="form-control"
                          value={this.state.detail?.cp3k_candidate_email}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Nomor HP
                      </Label>
                      <Col md="5">
                        <AvField
                          name="cp3k_candidate_phone_number"
                          placeholder="Nomor HP"
                          errorMessage="Masukkan Nomor HPP"
                          type="number"
                          className="form-control"
                          value={this.state.detail?.cp3k_candidate_phone_number}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">NIK</Label>
                      <Col md="5">
                        <AvField
                          name="cp3k_candidate_nik"
                          placeholder="NIK"
                          errorMessage="Masukkan NIK"
                          type="text"
                          className="form-control"
                          value={this.state.detail?.cp3k_candidate_nik}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Nomor KK
                      </Label>
                      <Col md="5">
                        <AvField
                          name="cp3k_candidate_familiy_card_number"
                          placeholder="Nomor KK"
                          errorMessage="Masukkan Nomor KK"
                          type="text"
                          className="form-control"
                          value={
                            this.state.detail
                              ?.cp3k_candidate_familiy_card_number
                          }
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Nomor NPWP
                      </Label>
                      <Col md="5">
                        <AvField
                          name="cp3k_candidate_npwp_number"
                          placeholder="Nomor NPWP"
                          errorMessage="Masukkan Nomor NPWP"
                          type="text"
                          className="form-control"
                          value={this.state.detail?.cp3k_candidate_npwp_number}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">NIP</Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_nip"
                          placeholder="NIP"
                          errorMessage="Masukkan NIP"
                          type="text"
                          className="form-control"
                          value={this.state.detail?.cp3k_candidate_nip}
                          validate={{ required: { value: false } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Tempat Lahir
                      </Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_place_of_birth_national"
                          type="text"
                          className="form-control"
                          value={this.state.birthNational}
                          validate={{ required: { value: false } }}
                          disabled={true}
                        />
                      </Col>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_place_of_birth_country_name"
                          type="text"
                          className="form-control"
                          value={
                            this.state.detail
                              ?.cp3k_candidate_place_of_birth_country_name
                          }
                          validate={{ required: { value: false } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row
                      className="mb-3"
                      style={
                        this.state.birthNational == "Dalam Negeri"
                          ? {}
                          : { display: "none" }
                      }
                    >
                      <Label className="col-md-3 col-form-label"></Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_place_of_birth_province_name"
                          type="text"
                          className="form-control"
                          value={
                            this.state.detail
                              ?.cp3k_candidate_place_of_birth_province_name
                          }
                          validate={{ required: { value: false } }}
                          disabled={true}
                        />
                      </Col>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_place_of_birth_city_name"
                          type="text"
                          className="form-control"
                          value={
                            this.state.detail
                              ?.cp3k_candidate_place_of_birth_city_name
                          }
                          validate={{ required: { value: false } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row
                      className="mb-3"
                      style={
                        this.state.birthNational == "Dalam Negeri"
                          ? { display: "none" }
                          : {}
                      }
                    >
                      <Label className="col-md-3 col-form-label"></Label>
                      <Col md="5">
                        <AvField
                          name="cp3k_candidate_place_of_birth_national"
                          placeholder="Kota..."
                          type="text"
                          errorMessage="Masukkan Kota"
                          className="form-control"
                          value={
                            this.state.detail
                              ?.cp3k_candidate_place_of_birth_city_text
                          }
                          validate={{
                            required: {
                              value:
                                this.state.birthNational == "Dalam Negeri"
                                  ? false
                                  : true,
                            },
                          }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Kode Pos
                      </Label>
                      <Col md="5">
                        <AvField
                          name="cp3k_candidate_postal_code"
                          placeholder="Kode Pos"
                          errorMessage="Masukkan Kode Pos"
                          type="number"
                          className="form-control"
                          value={this.state.detail?.cp3k_candidate_postal_code}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">Alamat</Label>
                      <Col md="5">
                        <AvField
                          name="cp3k_candidate_address"
                          placeholder="Alamat"
                          errorMessage="Masukkan Alamat"
                          type="textarea"
                          className="form-control"
                          value={this.state.detail?.cp3k_candidate_address}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Tanggal Lahir
                      </Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_date_of_birth"
                          placeholder="Tanggal Lahir"
                          errorMessage="Masukkan Tanggal Lahir"
                          type="date"
                          className="form-control"
                          value={
                            this.state.detail?.cp3k_candidate_date_of_birth
                          }
                          validate={{ required: { value: false } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Jenis Kelamin
                      </Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_gender_name"
                          type="text"
                          className="form-control"
                          value={this.state.detail?.cp3k_candidate_gender_name}
                          validate={{ required: { value: false } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Status Kawin
                      </Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_marital_status_name"
                          type="text"
                          className="form-control"
                          value={
                            this.state.detail
                              ?.cp3k_candidate_marital_status_name
                          }
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Pendidikan Terakhir
                      </Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_last_education_name"
                          type="text"
                          className="form-control"
                          value={
                            this.state.detail
                              ?.cp3k_candidate_last_education_name
                          }
                          validate={{ required: { value: false } }}
                          disabled={true}
                        />
                      </Col>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_last_education_major"
                          placeholder="Program Studi / Jurusan"
                          errorMessage="Masukkan Program Studi"
                          type="text"
                          className="form-control"
                          value={
                            this.state.detail
                              ?.cp3k_candidate_last_education_major
                          }
                          validate={{ required: { value: false } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Golongan
                      </Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_rank_name"
                          type="text"
                          className="form-control"
                          value={`${this.state.detail?.cp3k_candidate_rank_name}`}
                          validate={{ required: { value: false } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">Jabatan</Label>
                      <Col md="6">
                        <AvField
                          name="cp3k_candidate_position_name"
                          type="text"
                          className="form-control"
                          value={
                            this.state.detail?.cp3k_candidate_position_name
                          }
                          validate={{ required: { value: false } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Unit Kerja
                      </Label>
                      <Col md="6">
                        <AvField
                          name="cp3k_candidate_work_unit_name"
                          type="text"
                          className="form-control"
                          value={
                            this.state.detail?.cp3k_candidate_work_unit_name
                          }
                          validate={{ required: { value: false } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">Bank</Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_account_bank_name"
                          type="text"
                          className="form-control"
                          value={
                            this.state.detail?.cp3k_candidate_account_bank_name
                          }
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Nomor Rekening
                      </Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_account_bank_number"
                          type="text"
                          className="form-control"
                          value={
                            this.state.detail
                              ?.cp3k_candidate_account_bank_number
                          }
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Nama Rekening
                      </Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_account_name"
                          type="text"
                          className="form-control"
                          value={this.state.detail?.cp3k_candidate_account_name}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">Agama</Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_religion_name"
                          type="text"
                          className="form-control"
                          value={
                            this.state.detail?.cp3k_candidate_religion_name
                          }
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <hr />

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        File SK PPPK <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <FileInput
                          name="document"
                          accept=".pdf"
                          validate={{ required: { value: true } }}
                          errorMessage="Pilih File SK PPPK"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        File SPMT <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <FileInput
                          name="document_spmt"
                          accept=".pdf"
                          validate={{ required: { value: true } }}
                          errorMessage="Pilih File SPMT"
                        />
                      </Col>
                      <Col md="3">
                        <a
                          target={"_blank"}
                          className="btn btn-sm btn-success"
                          onClick={this.downloadDraftSPMT}
                        >
                          Download Draft <i className="fa fa-download ms-1"></i>
                        </a>
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="document_contract"
                        className="col-md-3 col-form-label"
                      >
                        File Kontrak Kerja{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <FileInput
                          name="document_contract"
                          accept=".pdf"
                          validate={{ required: { value: true } }}
                          errorMessage="Pilih File Kontrak Kerja"
                        />
                      </Col>
                      <Col md="3">
                        {this.state.dataForm.nip_pejabat !== null ? (
                          <a
                            target={"_blank"}
                            className="btn btn-sm btn-success"
                            onClick={this.downloadTemplatePerjanjian}
                          >
                            Download Draft{" "}
                            <i className="fa fa-download ms-1"></i>
                          </a>
                        ) : (
                          "-"
                        )}
                      </Col>
                    </Row>

                    {/* <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        File SPMT <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <FileInput
                          name="document_spmt"
                          accept=".pdf"
                          validate={{ required: { value: true } }}
                          errorMessage="Pilih File SPMT"
                        />
                      </Col>
                      <Col md="3">
                        {this.state.dataForm.nip_pejabat ? (
                          <>
                            {this.state.dataForm.nip_pejabat !== null ? (
                              <a
                                target={"_blank"}
                                className="btn btn-sm btn-success"
                                onClick={this.downloadDraftSPMT}
                                // href={this.state.document_spmt?.documents_path}
                              >
                                Download Draft{" "}
                                <i className="fa fa-download ms-1"></i>
                              </a>
                            ) : (
                              "-"
                            )}
                          </>
                        ) : (
                          <a className="btn btn-sm btn-secondary disabled">
                            Download Draft{" "}
                            <i className="fa fa-download ms-1"></i>
                          </a>
                        )}
                      </Col>
                    </Row> */}

                    <Row className="mb-3">
                      <label
                        htmlFor="document_kk"
                        className="col-md-3 col-form-label"
                      >
                        File Kartu Keluarga{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <FileInput
                          name="document_kk"
                          accept=".pdf"
                          validate={{ required: { value: true } }}
                          errorMessage="Pilih File Kartu Keluarga"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="document_akta_anak"
                        className="col-md-3 col-form-label"
                      >
                        File Akta Lahir Anak{" "}
                      </label>
                      <Col md="5">
                        <FileInput
                          name="document_akta_anak"
                          accept=".pdf"
                          // validate={{ required: { value: true } }}
                          errorMessage="Pilih File Akta Lahir Anak"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="document_akta_nikah"
                        className="col-md-3 col-form-label"
                      >
                        File Akta Nikah
                      </label>
                      <Col md="5">
                        <FileInput
                          name="document_akta_nikah"
                          accept=".pdf"
                          // validate={{ required: { value: true } }}
                          errorMessage="Pilih File Akta Nikah"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="document_bank"
                        className="col-md-3 col-form-label"
                      >
                        File Buku Tabungan{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <FileInput
                          name="document_bank"
                          accept=".pdf"
                          validate={{ required: { value: true } }}
                          errorMessage="Pilih File Buku Tabungan"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="document_npwp"
                        className="col-md-3 col-form-label"
                      >
                        File NPWP <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <FileInput
                          name="document_npwp"
                          accept=".pdf"
                          validate={{ required: { value: true } }}
                          errorMessage="Pilih File NPWP"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        File Prajab
                        {/* <span className="text-danger">*</span> */}
                      </Label>
                      <Col md="5">
                        <FileInput
                          name="document_prajab"
                          accept=".pdf"
                          // validate={{
                          //   required: {
                          //     value: this.state.document_prajab === null,
                          //   },
                          // }}
                          errorMessage="Pilih File Prajab"
                          //  this.state.document_prajab
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        File Medical Check Up{" "}
                        <span className="text-danger">*</span>
                      </Label>
                      <Col md="5">
                        <FileInput
                          name="document_mcu"
                          accept=".pdf"
                          validate={{
                            required: {
                              value: true,
                            },
                          }}
                          errorMessage="Pilih File Medical Check Up"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link
                          to={`/kepegawaian/dokumen_pengangkatan_pppk.html`}
                        >
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan Data
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          // failedInfo="Data gagal disimpan"
          // failedTitle={this.state.failedTitle}
          failedInfo={this.state.failedInfo}
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to={`/kepegawaian/dokumen_pengangkatan_pppk.html`} />
        ) : null}
      </Fragment>
    );
  }
}

export default IndexView;
